import React, { useLayoutEffect, useRef, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Layout from './AppLayout';
import Header from '../../../shared/components/layout/Header';
import WhatsAppCampaignTabs from './WhatsAppCampaignTabs';
import { useSidebar } from '../../../shared/contexts/SidebarContext';
import { useInboxStream } from '../../hooks/useInboxStream';

const WhatsAppCampaignLayout = () => {
  const { collapsed } = useSidebar();

  // Connect the WhatsApp inbox SSE stream for the whole campaigns section, so
  // conversation/message updates (and the Inbox tab badge) stay live across tabs.
  useInboxStream({ enabled: true });
  const shellRef = useRef(null);
  const [shellHeight, setShellHeight] = useState(132);

  useLayoutEffect(() => {
    const node = shellRef.current;
    if (!node) return undefined;

    const updateHeight = () => {
      setShellHeight(node.getBoundingClientRect().height);
    };

    updateHeight();

    const observer = new ResizeObserver(updateHeight);
    observer.observe(node);

    return () => observer.disconnect();
  }, []);

  const fixedBarClass = `fixed z-[10] transition-all duration-300 ease-in-out ${
    collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
  }`;

  return (
    <Layout>
      <div
        ref={shellRef}
        className={`${fixedBarClass} top-0 bg-white shadow-sm border-b border-stone-200`}>
        <div className="[&>div]:border-b-0">
          <Header
            backArrow
            data={{
              name: 'WhatsApp Lead Campaigns',
              subtitle: 'Create and manage lead flow builders for your projects'
            }}
          />
        </div>

        <div className="border-t border-stone-100">
          <WhatsAppCampaignTabs />
        </div>
      </div>

      <div
        className="min-h-[calc(100vh-8rem)] bg-[#F8F9FA]"
        style={{
          marginTop: shellHeight,
          '--wa-campaign-shell-height': `${shellHeight}px`
        }}>
        <Outlet />
      </div>
    </Layout>
  );
};

export default WhatsAppCampaignLayout;
